import React from "react";
import { Accordion } from "react-bootstrap";

const FaqSafari = ({ safariViewData }) => {
  return (
    <div id="faq-tab-pane" role="tabpanel" aria-labelledby="faq-tab" className="tab-pane accordion-item mb-3">
      <div className="card bg-set accordion-collapse  card_bodyPadding">
        <div className="card-body ">
        <div class="itenary-title"><h6 class="fs-6 fw-bold pb-1">FAQs</h6></div>
          <div className="faq_section">
            {Array.isArray(safariViewData?.faqs) && safariViewData.faqs.length > 0 ? (
              <Accordion defaultActiveKey="" className="inner_accordion">
                {safariViewData.faqs.map((faq, index) => (
                  <Accordion.Item eventKey={index.toString()} key={index} className="mb-3">
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body>
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            ) : (
              <p>No FAQs available for this safari.</p>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

export default FaqSafari;
